import { Route, Routes, Navigate } from 'react-router';
import { Login } from './pages/Login/Login';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Sessions } from './pages/Sessions/Sessions';
import { Events } from './pages/Events/Events';
import { KillSwitches } from './pages/KillSwitches/KillSwitches';
import { Rulesets } from './pages/Rulesets/Rulesets';
import { Releases } from './pages/Releases/Releases';
import { ClientBuilds } from './pages/ClientBuilds/ClientBuilds';
import { Reports } from './pages/Reports/Reports';
// Hardening 2.4 — métricas de eficácia da detecção
import { Efficacy } from './pages/Efficacy/Efficacy';
import { Sanctions } from './pages/Sanctions/Sanctions';
import { Diagnostics } from './pages/Diagnostics/Diagnostics';
import { SupportDiag } from './pages/SupportDiag/SupportDiag';
import { Cleanup } from './pages/Cleanup/Cleanup';
// Sessão 1 Frente A — novas pages
import { Incidents } from './pages/Incidents/Incidents';
import { IncidentDetail } from './pages/Incidents/IncidentDetail';
import { Investigation } from './pages/Investigations/Investigation';
import { TrustedProxies } from './pages/TrustedProxies/TrustedProxies';
// Fase 3 — busca de conta, histórico por período e a FILA DE BAN
import { Accounts } from './pages/Accounts/Accounts';
import { AccountDetail } from './pages/Accounts/AccountDetail';
import { BanQueue } from './pages/BanQueue/BanQueue';
import { Layout } from './components/layout/Layout';
import { PrivateRoute } from './routes/PrivateRoute';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/efficacy" element={<Efficacy />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/events" element={<Events />} />
        <Route path="/kill-switches" element={<KillSwitches />} />
        <Route path="/rulesets" element={<Rulesets />} />
        <Route path="/releases" element={<Releases />} />
        <Route path="/client-builds" element={<ClientBuilds />} />
        <Route path="/sanctions" element={<Sanctions />} />
        <Route path="/diagnostics" element={<Diagnostics />} />
        <Route path="/support-diag" element={<SupportDiag />} />
        <Route path="/cleanup" element={<Cleanup />} />
        <Route path="/reports/daily" element={<Reports />} />
        {/* Sessão 1 Frente A — Incidents / Investigations / TrustedProxies */}
        <Route path="/incidents" element={<Incidents />} />
        <Route path="/incidents/:uuid" element={<IncidentDetail />} />
        <Route path="/investigations/:type/:value" element={<Investigation />} />
        <Route path="/trusted-proxies" element={<TrustedProxies />} />
        {/* Fase 3 — o caminho que termina em ban:
            fila → conta → histórico por dia/semana/mês */}
        <Route path="/ban-queue" element={<BanQueue />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/accounts/:kind/:value" element={<AccountDetail />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
